import { FileText } from "lucide-react";
import Navbar from "@/components/Navbar";

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-display text-xl font-black text-foreground">{title}</h2>
    <div className="mt-2 space-y-3">{children}</div>
  </section>
);

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="page-shell max-w-4xl py-10 md:py-14">
        <header className="border-b border-border pb-8">
          <div className="flex items-center gap-2 text-primary">
            <FileText className="h-5 w-5" />
            <p className="text-xs font-black uppercase tracking-[0.25em]">Legal</p>
          </div>
          <h1 className="mt-3 font-display text-3xl font-black md:text-5xl">Terms of Service</h1>
          <p className="mt-3 text-sm text-muted-foreground">Effective 30 September 2026</p>
        </header>

        <div className="space-y-8 py-8 text-sm leading-7 text-muted-foreground md:text-base">
          <Section title="Using NamasteNetwork.ai">
            <p>NamasteNetwork.ai helps people discover events, contact organisers and, where enabled, buy tickets. You must provide accurate account and booking information and use the service lawfully.</p>
          </Section>
          <Section title="Event listings and organisers">
            <p>Organisers are responsible for their event details, availability, admission rules, changes and cancellations. Some listings link to an external ticket provider; that provider's terms and refund rules apply to those purchases.</p>
          </Section>
          <Section title="Namaste ticket purchases">
            <p>When Namaste checkout is enabled, the total price and any booking fee are shown before payment. Payments are processed securely by Stripe. A booking is confirmed only after successful payment and confirmation.</p>
            <p>Refunds and transfers follow the policy displayed for the event, subject to applicable consumer law. Booking fees may be non-refundable where permitted.</p>
          </Section>
          <Section title="Tickets and entry">
            <p>Keep ticket QR codes private. A ticket may be checked in once unless its terms say otherwise. Venues and organisers may enforce reasonable entry, age, safety and conduct rules.</p>
          </Section>
          <Section title="Organiser accounts">
            <p>Organisers must have authority to publish submitted content and must keep event, pricing, capacity and contact details accurate. Ticketing and Stripe Connect features may require approval before activation.</p>
          </Section>
          <Section title="Content and acceptable use">
            <p>Do not upload unlawful, misleading, infringing, abusive or unsafe content; interfere with the service; misuse tickets or scanner access; or attempt unauthorised access. We may remove content or restrict accounts to protect users and the platform.</p>
          </Section>
          <Section title="Service availability">
            <p>We work to keep the service accurate and available, but cannot guarantee uninterrupted operation or that third-party services will always be available. Nothing in these terms excludes rights or liability that cannot legally be excluded.</p>
          </Section>
          <Section title="Account deletion and privacy">
            <p>You can request account deletion from the mobile Profile screen. We remove the account and personal profile data while retaining limited anonymised transaction records where required for accounting, fraud prevention, disputes or legal obligations.</p>
            <p>Read our <a href="/privacy" className="font-bold text-primary underline underline-offset-4">Privacy Policy</a> for details.</p>
          </Section>
          <Section title="Contact">
            <p>Questions can be sent to <a href="mailto:namastenetwork.ai@gmail.com" className="font-bold text-primary underline underline-offset-4">namastenetwork.ai@gmail.com</a>.</p>
          </Section>
        </div>
      </main>
    </div>
  );
}
